<script setup lang="ts">
import { ref } from 'vue'
import { Capacitor } from '@capacitor/core'
import { useHaptic } from '@caks/shared/composables/useHaptic'

interface Props {
  ingredientsList: Array<{
    id: number
    name: string
    image: string
    cost: number
  }>
}

const props = defineProps<Props>()
const { hapticsImpactHeavy } = useHaptic()

const emit = defineEmits<{
  (e: 'select', value: { id: string; price: number }): void
  (e: 'remove', value: { id: string; price: number }): void
}>()

const selectedItems = ref([])
const selectIngredient = async (id: number, cost) => {
    if (Capacitor.isNativePlatform()) {
    await hapticsImpactHeavy()
  }

  for (let i = 0; i < selectedItems.value.length; i++) {
    if (selectedItems.value[i] === id) {
      // @ts-ignore
      emit('remove', {
        ...props.ingredientsList.find((el) => el.id === id),
      })
      selectedItems.value.splice(i, 1)

      return
    }
  }

  if(cost == 'Нет в наличии') return
  // @ts-ignore
  emit('select', {
    ...props.ingredientsList.find((el) => el.id === id),
  })
  selectedItems.value.push(id)
}
</script>

<template>
  <div class="ingredients">
    <div
      class="ingredients__tile tile"
      v-if="ingredientsList.length"
      v-for="ingredient of ingredientsList"
      @click="selectIngredient(ingredient.id, ingredient.cost)"
      :class="{
        tile_active: selectedItems.find((id) => id === ingredient.id),
        tile_disabled: ingredient.cost == 'Нет в наличии'
      }"
    >
      <div class="tile__image">
        <img :src="ingredient.image" :alt="ingredient.name" />
      </div>
      <h4 class="tile__name" v-text="ingredient.name" />
      <div class="tile__price" v-text="`${ingredient.cost} ${ingredient.cost != 'Нет в наличии'? '₽' : ''}`" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.ingredients {
  /* display: flex;
  justify-content: center; */
  /* flex-wrap: wrap; */
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;

  &__tile {
    // 1.1 w к 1.6h
    /* width: 110px;
    height: 160px; */
    cursor: pointer;
  }
}
.tile {
  background-color: $white;
  border-radius: 8px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
  padding: 8px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: 1.5px solid $white;
  @extend %hover-transition;

  &_active {
    border-color: $primary-green;
    background-color: $sub-green;
  }

  &__image {
    max-width: 100%;
    height: 84px;
    border-radius: 8px;
    overflow: hidden;
    img {
      width: 100%;
    }

    .ion-page & {
      height: 100px;

      img {
        width: 100%;
        object-fit: cover;
        height: 100%;
      }
    }
  }

  &__name {
    min-height: 24px;
    margin-top: 8px;
    @include h7-1;
  }

  &__price {
    @include h5-6;

    .tile_disabled & {
      font-size: 11px;
      font-weight: 800;
    }
  }
}
</style>
